var map = {
	"./1.jpg": 5183,
	"./3.webp": 6382,
	"./beauty.webp": 5293,
	"./dashboard.webp": 6011,
	"./deck-cards.png": 8001,
	"./diploma-bac-1.jpg": 39,
	"./diploma-bac-2.jpg": 5816,
	"./diploma-spec-1.jpg": 1532,
	"./diploma-spec-2.jpg": 4331,
	"./en.svg": 3931,
	"./facebook.svg": 1378,
	"./final-hillel.webp": 4384,
	"./fox-digital-blue.webp": 5354,
	"./fox-digital.webp": 9679,
	"./future-academy.webp": 1941,
	"./hobby-art.webp": 5595,
	"./icons8-telegram-app.svg": 4450,
	"./icons8-telegram.svg": 8204,
	"./instagram.svg": 6166,
	"./istockphoto-539118773-1024x1024.jpg": 4097,
	"./js.jpg": 5773,
	"./linkedin.svg": 3816,
	"./load.png": 8856,
	"./localize.webp": 6814,
	"./mail.svg": 683,
	"./meliorit.webp": 248,
	"./only.webp": 5847,
	"./phone.svg": 9070,
	"./promo-generator.webp": 1908,
	"./react-currency.webp": 5552,
	"./react-users.webp": 7949,
	"./ru.svg": 9437,
	"./sertificat-1.png": 3333,
	"./sertificat-2.png": 3897,
	"./sertificat-3.png": 3344,
	"./sertificat-4.png": 9839,
	"./sertificat-5.png": 822,
	"./spin-wheel.webp": 755,
	"./uk.svg": 2854
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 1382;